import { troopTiersPower } from './constants'
import unidecode from 'unidecode'

export const env = window.__ENV__

export const randomString = (length) => {
    const characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.split('')
    const stringLength = length || Math.floor(Math.random() * characters.length)

    let string = ''
    Array(stringLength).fill().forEach(() => string += characters[Math.floor(Math.random() * characters.length)])

    return string
}

export const capitalize = (string) => {
    if (!string) return ''
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export const formatThousands = (number, separator) => {
    if (!number) return ''
    const [integerPart, decimalPart] = number.toString().split('.')
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator || ' ')
    return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger
}

export const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
    const rawData = window.atob(base64)
    return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)))
}

export const deepMatch = (string, searchKey) => {
    const filterKey = searchKey?.toLowerCase()
    const regularString = string?.toLowerCase() || ''
    const normalizedString = unidecode(regularString)
    const regularMatch = !filterKey || regularString.includes(filterKey)
    const specialMatch = !filterKey || normalizedString.includes(filterKey)
    
    return regularMatch || specialMatch
}

export const mgeRating = ({ merits, power, mercenaryTech1, mercenaryTech2, troopTiers, mge, seasonalRecords }, log) => {
    if (!power || !merits || !mge?.targetUnitType) return 0

    const meritRatioThreshold = 0.15
    const curveWeight = 0.8
    const techWeight = 0.5
    const seasonalMeritsWeight = 100
    const seasonalEffortMaximumMultiplier = 0.1

    const boostMultiplier = mge.boost ? 1.1 : 1
    const debuffMultiplier = mge.debuff ? 0.9 : 1
    const troopTierMultiplier = troopTiersPower[troopTiers[mge.targetUnitType]] / 10

    const meritRatio = merits / power
    const deviation = meritRatioThreshold / meritRatio
    const tech1 = mercenaryTech1[mge.targetUnitType] || 0
    const tech2 = mercenaryTech2[mge.targetUnitType] || 0

    const balance = Math.exp(-curveWeight * deviation)
    const strength = Math.pow(power * troopTierMultiplier, curveWeight)
    const specialty = Math.pow((100 + (tech1 + tech2) / 2) / 100, techWeight)

    const currentSeason = seasonalRecords.find((record) => record.current)
    const pastSeason = seasonalRecords.find((record) => record.stellarSeason.name === currentSeason.stellarSeason.name - 1)
    const seasonalEffort = (pastSeason?.seasonalMerits || 0) * seasonalMeritsWeight / power
    const seasonalEffortMultiplier = 1 + seasonalEffortMaximumMultiplier * (seasonalEffort / (1 + seasonalEffort))

    const baseRating = Math.pow(strength * balance * specialty, 0.3)
    const rating = (baseRating * boostMultiplier * debuffMultiplier).toFixed(2)

    return rating
}